/******************************************************************
 * Archivo : client/src/queries/fetchRoleById.js
 * Proyecto: CB30
 * Módulo  : Administración de Roles
 *
 * Propósito:
 * Obtener un Rol por su identificador.
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query RoleById($id: ID!) {

    roleById(id: $id) {

      id
      code
      label
      description
      active
      permissions {
      id
      }

    }

  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchRoleById.js